import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import {
  ComputedProductStatus,
  InventoryByLotListSortField,
  InventoryByPalletListSortField,
  InventoryByProductListSortField,
  InventoryByTransactionListSortField,
  InventoryStatus,
  SortingOrder,
} from "@/graphql/codegen/graphql"

export const productInventoriesSearchSchema = z.object({
  query: z.string().optional(),
  field: z.nativeEnum(InventoryByProductListSortField).optional(),
  order: z.nativeEnum(SortingOrder).optional(),
  warehouseAreaId: z.string().optional(),
  productStatuses: fallback(z.array(z.nativeEnum(ComputedProductStatus)), [ComputedProductStatus.Active]),
  inventoryStatuses: fallback(z.array(z.nativeEnum(InventoryStatus)).optional(), []),
  productManagerIds: z.array(z.string()).optional(),
  productClassIds: z.array(z.string()).optional(),
})

export type ProductInventoriesSearchParams = z.infer<typeof productInventoriesSearchSchema>

export const productInventoryDetailsSearchSchema = z.object({
  warehouseAreaId: z.string().optional(),
})

export type ProductInventoryDetailsSearchParams = z.infer<typeof productInventoryDetailsSearchSchema>

export const productInventoryLotsSearchSchema = productInventoryDetailsSearchSchema.extend({
  field: fallback(z.nativeEnum(InventoryByLotListSortField), InventoryByLotListSortField.ExpireDate),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export type ProductInventoryLotsSearchParams = z.infer<typeof productInventoryLotsSearchSchema>

export const productInventoryPalletsSearchSchema = productInventoryDetailsSearchSchema.extend({
  query: z.string().optional(),
  field: fallback(z.nativeEnum(InventoryByPalletListSortField), InventoryByPalletListSortField.RemainingShelfLife),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export type ProductInventoryPalletsSearchParams = z.infer<typeof productInventoryPalletsSearchSchema>

export const productInventoryTransactionsSearchSchema = productInventoryDetailsSearchSchema.extend({
  query: z.string().optional(),
  field: fallback(z.nativeEnum(InventoryByTransactionListSortField), InventoryByTransactionListSortField.CreatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
})

export type ProductInventoryTransactionsSearchParams = z.infer<typeof productInventoryTransactionsSearchSchema>
